import styles from './LoadingSpinner.module.scss'

const LoadingSpinnerComponent = () => {
    return (
        <div className={styles.loading}>
            <div></div><div></div><div></div><div></div>
        </div>
    )
}

export default LoadingSpinnerComponent
